import api from './api';
export const EstyService = {
    searchProducts(query, limit = 10) {
        return api.get('/api/etsy/products', { params: { query, limit } });
    },
    searchOrders(email, limit = 10) {
        return api.get('/api/etsy/orders', { params: { email, limit } });
    },
};
